import React from 'react';
import { PageHero } from '../components/PageHero';
import { SectionStage } from '../components/SectionStage';
import { Integrations } from '../components/Integrations';
export function IntegrationsPage() {
  return <>
      <PageHero eyebrow="Integrations" title="The Signal Fabric" titleMuted="Connects to your stack." description="Periscan uses your existing tools as sensors, controls, evidence sources, and remediation paths." bg="none" data-id="element-1713" />

      <SectionStage fx="constellation" data-id="element-1714">
        <Integrations data-id="element-1715" />
      </SectionStage>

      {/* Placeholder for structured integrations by purpose: Signal sources, Control observers, Validation targets, Remediation destinations, Evidence sinks */}
    </>;
}